import {NumberHelper} from 'app/lib/numberHelper';
import {Amount} from "app/model/amount";

export const Calculate = (amount, exchange) => {
    if (amount.amount < 0) {
        throw new Error('Calculator works only for positive values');
    }

    const counterCurrency = exchange.getCounterCurrency(amount.currency);

    if (
        (exchange.inversion && amount.currency === exchange.quoted) ||
        (!exchange.inversion && amount.currency === exchange.base)
    ) {
        return Amount.createMoney(NumberHelper.round(amount.amount * exchange.rate, 0), counterCurrency);
    }

    return Amount.createMoney(NumberHelper.round(amount.amount / exchange.rate, 0), counterCurrency);
};


export const CalculateExchange = (amount, exchange) => {
    const defineResult = (value, currency) => `${value.toFixed(4)}  ${exchange.getCounterCurrency(currency)}`;

    if (amount.amount < 0) {
        throw new Error('Calculator works only for positive values');
    }

    if (
        (exchange.inversion && amount.currency === exchange.quoted) ||
        (!exchange.inversion && amount.currency === exchange.base)
    ) {
        return defineResult(exchange.rate, exchange.base);
    }

    return defineResult((amount.amount / (exchange.rate * 100)), amount.currency);
};